import React from 'react'
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Clickable } from 'phoenix-components';
import ImageAlert from 'components/alert/ImageAlert';
import UploadReceipt from './UploadReceipt';
import styles from "./paymentLinkCard.module.css"
import { SnackBar } from 'ui/services';
import { useToggle } from 'hooks/common';
import { availableOnlinePaymentMethods, getCustomModes } from './paymentUtils';

export default function PaymentLinkCard({ shop, modes, selectedMode, isSelected, receipt, setReceipt }) {
  const [openImgAlert, toggleImgAlert,] = useToggle(false);

  const isOnline = selectedMode?.type === "online"
  const customModes = getCustomModes(shop, modes);
  const currentCustomMode = customModes?.find(
    mode => mode._id === selectedMode?.id);


  const copyToClipboard = async () => {
    const regex = /(<([^>]+)>)/ig;
    const textToCpy = currentCustomMode?.details.replace(regex, '');
    if ('clipboard' in navigator) {
      navigator.clipboard.writeText(textToCpy);
      SnackBar.show('Copied to clipboard');
    }
  };

  if (isSelected) {
    if (isOnline) {
      return <div className={styles.partners}>
        {availableOnlinePaymentMethods?.map((x, i) => <img key={i} className={styles.onlineIcon} src={x} alt="" />)}
      </div>
    } else {
      const { mode, details, media } = currentCustomMode;
      const paymentImg = media[0] ?? "";
      return <div>
        {openImgAlert && (
          <ImageAlert
            image={paymentImg}
            onClose={toggleImgAlert}
          />
        )}
        <div className={cx(styles.detailSection)}>
          Payment Details
          <div className={styles.detailsContainer}>
            <div className={styles.flex}>
              <div className={cx(styles.subtext)}>
                {mode}
              </div>
              :
              <div
                id="RTE"
                className={styles.html}
                dangerouslySetInnerHTML={{ __html: details }}
              >
              </div>
              <Clickable className={styles.cpy} onClick={copyToClipboard}>
                <img src="/images/orders/copy.svg" alt="" />
              </Clickable>
            </div>
            {paymentImg && (
              <div className={styles.paymentImgContainer}>
                <p className={styles.paymentImgText}>Payment Image : </p>
                <div className={cx(styles.imgContainer)} style={{ backgroundImage: `url(${paymentImg})` }}>
                  <button className={styles.paymentImgBtn} onClick={toggleImgAlert}>View</button>
                </div>
              </div>)}
            <div className={styles.receiptConatiner}>
              <UploadReceipt
                images={media ?? []}
                setUrl={(url) => {
                  setReceipt(url);
                }}
                url={receipt}
              />
            </div>
            <div className={cx(styles.marginTop, styles.subtext, styles.flex)}>
              Heads up! We need your payment screenshot in order to accept your order. Go ahead and upload it below.
            </div>
          </div>
        </div>
      </div>
    }
  }
  return null;
}

PaymentLinkCard.propTypes = {
  shop: PropTypes.object.isRequired,
  modes: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  selectedMode: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  receipt: PropTypes.string.isRequired,
  setReceipt: PropTypes.string.isRequired
};
